// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"fdf4422e","472":"d4d2a025","690":"fe05fcd7"}[chunkId] + ".chunk.js";
};